import React, {useCallback} from 'react';

import {components, OptionProps} from 'react-select';
import styled from 'styled-components';

import {colors, breakpoint, font} from '../../../theme';

const Label = styled.div<{isSelected?: boolean}>`
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: ${(p) => (p.isSelected ? colors.white : colors.textGrey1)};
    margin-bottom: 4px;
`;
const Code = styled.div<{isSelected?: boolean}>`
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: ${(p) => (p.isSelected ? colors.white : colors.textGrey2)};
`;

export const CustomerCompanyNameOrTIN = (props: OptionProps<any, false>) => {
    const {data} = props;
    const itemData: {
        city: string;
        label: string;
        postalCode: string;
        value: string;
    } = {...data};
    return (
        <components.Option {...props}>
            <Label isSelected={props.isSelected}>{itemData.label}</Label>
            <Code isSelected={props.isSelected}>{itemData.value}</Code>
        </components.Option>
    );
};
